import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-white border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
          {/* Company Info */}
          <div className="md:col-span-1">
            <img
              src="https://static.readdy.ai/image/878aa561146e1949d21d2a461d90b0e2/14e74c46730e6ab6ad61437e0fb48d69.png"
              alt="The Stoll Agency, Inc. — Construction Insurance and Surety Bonds, Bucks County and Montgomery County Pennsylvania"
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm text-slate-400 leading-relaxed">
              Pennsylvania's trusted construction insurance and surety bond professionals serving Bucks County, Montgomery County, and all of PA since 1957.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-widest mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {[
                { label: 'Home', path: '/' },
                { label: 'About', path: '/about' },
                { label: 'Contractors', path: '/contractors' },
                { label: 'Major Projects', path: '/major-projects' },
                { label: 'Resources', path: '/resources' },
                { label: 'The Alliance', path: '/alliance' },
                { label: 'Blog', path: '/blog' },
                { label: 'Contact', path: '/contact' },
              ].map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-slate-400 hover:text-green-500 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-widest mb-4">Services</h3>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>Construction Insurance</li>
              <li>Surety Bonding</li>
              <li>Union Bonds</li>
              <li>Business Insurance</li>
              <li>Risk Management</li>
              <li>Performance Bonds</li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-widest mb-4">Service Areas</h3>
            <ul className="space-y-2 text-sm text-slate-400">
              <li className="flex items-center"><i className="ri-map-pin-line text-green-500 mr-2"></i>Bucks County, PA</li>
              <li className="flex items-center"><i className="ri-map-pin-line text-green-500 mr-2"></i>Montgomery County, PA</li>
              <li className="flex items-center"><i className="ri-map-pin-line text-green-500 mr-2"></i>Philadelphia, PA</li>
              <li className="flex items-center"><i className="ri-map-pin-line text-green-500 mr-2"></i>Chester County, PA</li>
              <li className="flex items-center"><i className="ri-map-pin-line text-green-500 mr-2"></i>Delaware County, PA</li>
              <li className="flex items-center"><i className="ri-map-pin-line text-green-500 mr-2"></i>All of Pennsylvania</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-500">
            Copyright &copy; 2025 The Stoll Agency, Inc. — All Rights Reserved. | Construction Insurance &amp; Surety Bonds | Bucks County &amp; Montgomery County, PA
          </p>
          <a
            href="https://www.theinsurancealliancenetwork.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-green-500 hover:text-green-400 transition-colors whitespace-nowrap"
          >
            Member of The Insurance Alliance
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
